import React, { useEffect, useState } from "react"
import { Typography } from "@/shared/ui/Typography"
import { TextField } from "@/shared/ui/TextField"
import { Button } from "@/shared/ui/Button"
import { Icon } from "@/shared/ui/Icon"
import { Footer } from "@/widgets/footer/Footer"
import { BaseTextArea } from "@/shared/ui/BaseTextArea"
import { UniqText } from "@/shared/uniq-text/UniqText"
import Wave from "react-wavify"

import cls from "./contact_block.module.scss"
import { classNames } from "@/shared/lib/classNames"
import { useCookies } from "react-cookie"
import { Link } from "react-router-dom"
import axios from "axios"

export const ContactBlock = () => {
    const [isHover, setHover] = useState(false)
    const [cookies, setCookie] = useCookies()

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [phone, setPhone] = useState("")
    const [message, setMessage] = useState("")
    const [checked, setChecked] = useState(false)
    const [isSent, setIsSent] = useState(false)

    const [fields, setFields] = useState({
        name: true,
        email: true,
        phone: true,
        message: true,
    })

    useEffect(() => {
        setName(cookies?.name ?? "")
        setEmail(cookies?.email ?? "")
        setPhone(cookies?.phone ?? "")
        setMessage(cookies?.message ?? "")
    })

    const onChangeName = (event) => {
        setName(event.target.value)
        setCookie("name", event.target.value)
    }

    const onChangeEmail = (event) => {
        setEmail(event.target.value)
        setCookie("email", event.target.value)
    }

    const onChangePhone = (event) => {
        setPhone(event.target.value)
        setCookie("phone", event.target.value)
    }

    const onChangeMessage = (event) => {
        setMessage(event.target.value)
        setCookie("message", event.target.value)
    }

    const handleMouseEnter = () => {
        setHover(true)
    }

    const handleMouseLeave = () => {
        setHover(false)
    }

    const onSubmit = () => {
        let isValidName = true
        let isValidEmail = true
        let isValidPhone = true
        let isValidMessage = true
        isValidName = !(String(name).trim() === "")
        isValidEmail = !(String(email).trim() === "")
        isValidPhone = !(String(phone).trim() === "")
        isValidMessage = !(String(message).trim() === "")
        
        setFields({
            name: isValidName,
            email: isValidEmail,
            phone: isValidPhone,
            message: isValidMessage,
        })

        axios
            .post("https://hz.axgrid.com/send", {
                email: String(email),
                name: String(name),
                phone: String(phone),
                message: String(message),
            })
            .then((r) => {
                setIsSent(true)
                setTimeout(() => {
                    setIsSent(false)
                }, 3000)
            })
            .catch(function (error) {
                setIsSent(true)
                setTimeout(() => {
                    setIsSent(false)
                }, 5000)
            })
    }

    return (
        <div
            id='contact_block'
            className={cls.contactBlock}>
            <div className={cls.wave}>
                <Wave
                    fill='url(#gradient)'
                    filter='url(#filter-1)'
                    amplitude={20}
                    speed={0.1}
                    points={2}>
                    <defs>
                        <linearGradient
                            id='gradient'
                            gradientTransform='rotate(90)'>
                            <stop
                                offset='10%'
                                stopColor='#CAFE14'
                            />
                            <stop
                                offset='50%'
                                stopColor='white'
                            />
                            <stop
                                offset='100%'
                                stopColor='white'
                            />
                        </linearGradient>
                        <filter id='filter-1'>
                            <feGaussianBlur
                                in='FillPaint'
                                stdDeviation='0, 5'
                            />
                        </filter>
                    </defs>
                </Wave>
            </div>
            <div className={cls.container}>
                <div className={cls.title}>
                    <UniqText />
                    <svg
                        className={cls.titleEmail}
                        width='401'
                        height='39'
                        viewBox='0 0 401 39'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                            d='M0.963021 20.584H5.28902C5.79302 25.75 9.15302 28.018 14.067 28.018C17.217 28.018 21.417 26.716 21.417 22.894C21.417 15.124 2.18102 20.206 2.18102 9.076C2.18102 2.902 7.68302 0.591998 13.017 0.591998C19.233 0.591998 24.231 3.784 24.525 10.462H20.367C19.863 6.094 17.133 4.288 12.807 4.288C10.203 4.288 6.42302 5.38 6.42302 8.614C6.42302 16.006 25.575 10.714 25.575 22.6C25.575 29.74 18.981 31.756 13.815 31.756C7.22102 31.756 1.38302 28.438 0.963021 20.584ZM32.9667 16.426H29.1867C29.1867 10.966 32.6727 8.698 37.7127 8.698C40.7787 8.698 44.1807 9.622 45.6087 12.562C46.1127 13.612 46.1547 14.83 46.1547 15.964V25.834C46.1547 27.682 46.4487 27.934 47.3307 27.934C47.6667 27.934 48.0447 27.892 48.3807 27.808V30.874C47.6247 31.126 46.8267 31.252 46.0287 31.252C44.0547 31.252 42.6687 30.412 42.6687 28.27C40.5687 30.454 38.3427 31.504 35.2347 31.504C31.3287 31.504 28.0947 29.404 28.0947 25.12C28.0947 18.358 35.8227 18.568 40.5687 17.392C41.6187 17.14 42.5427 16.678 42.5427 15.586C42.5427 12.814 40.1907 11.932 37.8387 11.932C34.6047 11.932 32.9667 13.108 32.9667 16.426ZM42.5847 22.516V19.786C38.1327 21.676 32.1687 20.878 32.1687 24.952C32.1687 27.304 34.2267 28.228 36.2847 28.228C39.5607 28.228 42.5847 25.834 42.5847 22.516ZM47.8659 9.37H52.2759L55.1319 16.762C56.3499 19.912 57.6939 23.062 58.5759 26.296C60.4239 20.626 62.4819 14.998 64.4979 9.37H68.8239L59.2059 33.772C58.2399 36.208 56.7699 37.846 53.9559 37.846C52.7799 37.846 51.6039 37.552 50.5119 37.132V33.772C51.3519 34.108 52.2339 34.402 53.1579 34.402C55.5519 34.402 56.0139 32.302 56.7279 30.496L47.8659 9.37ZM79.2051 1.348H83.3631V11.344C85.1691 9.496 87.3111 8.74 89.9151 8.74C92.1411 8.74 94.4511 9.412 95.8791 11.26C97.1811 12.94 97.2651 14.998 97.2651 17.014V31H93.1911V16.72C93.1911 13.906 91.7631 12.394 88.9071 12.394C85.2951 12.394 83.2791 14.788 83.2791 18.274V31H79.2051V1.348ZM116.649 24.322H120.555C119.631 28.312 116.817 31.588 111.483 31.588C104.847 31.588 101.067 26.716 101.067 20.332C101.067 14.326 104.595 8.74 111.147 8.74C117.699 8.74 120.849 14.284 120.849 20.206V21.214H105.183C105.393 24.994 107.325 28.144 111.399 28.144C114.087 28.144 115.767 26.758 116.649 24.322ZM105.183 18.19H116.565C116.565 14.914 114.675 12.016 111.147 12.016C107.745 12.016 105.687 14.578 105.183 18.19ZM124.755 1.348H128.787V31H124.755V1.348ZM133.932 1.348H137.964V31H133.932V1.348ZM152.308 8.656C153.526 8.656 154.744 8.866 155.878 9.286C160.54 11.05 162.43 15.25 162.43 19.954C162.43 26.464 158.944 31.714 151.972 31.714C145.294 31.714 141.766 26.59 141.766 20.332C141.766 13.78 145.42 8.656 152.308 8.656ZM152.308 12.142C147.562 12.142 145.84 16.174 145.84 20.332C145.84 24.364 147.646 28.27 152.14 28.27C156.886 28.27 158.356 24.028 158.356 19.996C158.356 13.528 154.702 12.142 152.308 12.142ZM187.82 10.21H190.676L189.29 16.51C188.786 18.82 188.114 21.298 188.114 23.692C188.114 24.49 188.366 25.54 189.374 25.54C190.298 25.54 191.222 24.784 191.852 24.112C194.414 21.34 195.758 17.098 195.758 13.318C195.758 7.06 191.516 3.364 185.468 3.364C176.06 3.364 168.71 11.974 168.71 21.13C168.71 29.278 174.674 33.898 182.444 33.898C188.03 33.898 192.524 31.546 196.514 27.766L197.858 29.488C193.868 33.562 188.198 36.208 182.486 36.208C179 36.208 175.178 35.2 172.28 33.226C168.248 30.454 166.358 25.918 166.358 21.13C166.358 10.336 174.758 1.096 185.762 1.096C193.112 1.096 198.194 5.716 198.194 13.192C198.194 17.56 196.682 22.222 193.658 25.456C192.314 26.884 190.424 28.06 188.45 28.06C186.224 28.06 185.048 26.59 184.964 24.49C183.494 26.464 181.562 28.018 179 28.018C175.094 28.018 173.498 24.658 173.498 21.214C173.498 16.132 176.774 9.286 182.36 9.286C184.754 9.286 186.266 10.672 187.19 12.814L187.82 10.21ZM182.654 11.932C178.79 11.932 176.816 17.518 176.816 21.046C176.816 23.188 177.782 25.288 180.176 25.288C183.998 25.288 186.14 19.87 186.14 16.216C186.14 14.116 185.048 11.932 182.654 11.932ZM206.866 16.426H203.086C203.086 10.966 206.572 8.698 211.612 8.698C214.678 8.698 218.08 9.622 219.508 12.562C220.012 13.612 220.054 14.83 220.054 15.964V25.834C220.054 27.682 220.348 27.934 221.23 27.934C221.566 27.934 221.944 27.892 222.28 27.808V30.874C221.524 31.126 220.726 31.252 219.928 31.252C217.954 31.252 216.568 30.412 216.568 28.27C214.468 30.454 212.242 31.504 209.134 31.504C205.228 31.504 201.994 29.404 201.994 25.12C201.994 18.358 209.722 18.568 214.468 17.392C215.518 17.14 216.442 16.678 216.442 15.586C216.442 12.814 214.09 11.932 211.738 11.932C208.504 11.932 206.866 13.108 206.866 16.426ZM216.484 22.516V19.786C212.032 21.676 206.068 20.878 206.068 24.952C206.068 27.304 208.126 28.228 210.184 28.228C213.46 28.228 216.484 25.834 216.484 22.516ZM223.918 9.37H228.874C230.512 11.722 232.066 14.116 233.662 16.51C235.132 14.074 236.644 11.722 238.198 9.37H243.112L235.678 19.534L244.036 31H239.248C237.316 28.228 235.342 25.456 233.536 22.6C232.906 23.608 232.234 24.574 231.562 25.54C230.344 27.388 229.084 29.194 227.824 31H222.994L231.436 19.534L223.918 9.37ZM260.626 9.37H264.406V29.824C264.406 32.218 264.196 34.192 262.39 35.956C260.332 37.972 257.308 38.392 254.578 38.392C250.42 38.392 246.052 36.712 246.052 31.924H249.916C250.126 34.318 252.814 35.032 254.788 35.032C258.736 35.032 260.71 33.52 260.71 29.446V27.346C259.156 29.32 256.552 30.244 254.116 30.244C248.194 30.244 244.96 25.288 244.96 19.744C244.96 14.242 248.068 8.698 254.158 8.698C256.846 8.698 259.03 9.706 260.626 11.848V9.37ZM254.788 12.352C250.756 12.352 249.118 15.796 249.118 19.408C249.118 23.104 250.756 26.506 254.914 26.506C259.24 26.506 260.668 23.398 260.668 19.534C260.668 15.88 258.904 12.352 254.788 12.352ZM269.552 9.37H273.458V13.024C274.424 10.798 276.692 8.866 279.212 8.866C280.01 8.866 280.598 8.992 281.312 9.37V13.024C280.724 12.814 280.136 12.688 279.506 12.688C277.658 12.688 275.936 13.738 274.886 15.25C273.836 16.762 273.584 18.358 273.584 20.164V31H269.552V9.37ZM283.98 1.348H288.054V6.01H283.98V1.348ZM283.98 9.37H288.054V31H283.98V9.37ZM308.067 1.348H312.057V31H308.025V28.522C306.135 30.706 304.035 31.63 301.095 31.63C294.585 31.63 291.813 26.044 291.813 20.206C291.813 14.368 294.543 8.698 301.137 8.698C303.909 8.698 306.303 9.706 308.067 11.848V1.348ZM301.935 12.016C297.357 12.016 296.013 16.468 296.013 20.29C296.013 24.154 297.525 28.354 302.019 28.354C306.597 28.354 308.193 23.944 308.193 20.038C308.193 16.09 306.429 12.016 301.935 12.016ZM321.592 31H317.098V26.548H321.592V31ZM345.049 16.678H341.185C340.807 13.906 338.581 12.1 335.809 12.1C331.273 12.1 329.173 16.048 329.173 20.122C329.173 24.448 331.231 28.186 335.977 28.186C339.253 28.186 340.975 25.918 341.521 22.936H345.301C344.881 29.026 340.345 31.672 335.599 31.672C328.837 31.672 325.099 26.758 325.099 20.29C325.099 13.696 329.047 8.656 335.851 8.656C340.639 8.656 344.881 11.638 345.049 16.678ZM357.985 8.656C359.203 8.656 360.421 8.866 361.555 9.286C366.217 11.05 368.107 15.25 368.107 19.954C368.107 26.464 364.621 31.714 357.649 31.714C350.971 31.714 347.443 26.59 347.443 20.332C347.443 13.78 351.097 8.656 357.985 8.656ZM357.985 12.142C353.239 12.142 351.517 16.174 351.517 20.332C351.517 24.364 353.323 28.27 357.817 28.27C362.563 28.27 364.033 24.028 364.033 19.996C364.033 13.528 360.379 12.142 357.985 12.142ZM371.909 9.37H375.689V12.436C376.655 10.042 379.175 8.74 381.653 8.74C384.341 8.74 386.273 9.874 387.239 12.436C388.709 9.916 390.851 8.74 393.791 8.74C396.017 8.74 398.243 9.58 399.419 11.596C400.385 13.276 400.469 15.712 400.469 17.602V31H396.311V17.266C396.311 14.746 395.975 12.31 392.867 12.31C391.271 12.31 389.885 13.024 389.045 14.368C388.247 15.628 388.205 17.14 388.205 18.61V31H384.131V16.804C384.131 14.41 383.543 12.268 380.645 12.268C376.487 12.268 376.025 16.3 376.025 18.61V31H371.909V9.37Z'
                            fill='black'
                        />
                    </svg>
                </div>
                <div className={cls.form}>
                    <div
                        id='contact-block-form'
                        className={cls.textFields}>
                        <TextField
                            value={name}
                            onChange={onChangeName}
                            isValid={fields.name}
                            placeholder={"Your Name"}
                        />
                        <TextField
                            value={email}
                            type='email'
                            onChange={onChangeEmail}
                            isValid={fields.email}
                            placeholder={"Email"}
                        />
                        <TextField
                            value={phone}
                            type='tel'
                            onChange={onChangePhone}
                            isValid={fields.phone}
                            placeholder={"Phone"}
                        />
                    </div>
                    <BaseTextArea
                        className={cls.textArea}
                        value={message}
                        onChange={onChangeMessage}
                        isValid={fields.message}
                        placeholder='Tell us more about project'
                    />
                </div>
                <div className={cls.privacyPolicy}>
                    <input
                        className={cls.privacyCheckBox}
                        type='checkbox'
                        id='todo'
                        name='todo'
                        value={checked}
                        onChange={(e) =>
                            setChecked(!checked)
                        }
                    />
                    <label
                        className={cls.checkBoxLabel}
                        for='todo'></label>

                    <p>
                        By sending this form I confirm that
                        I have read and accept{" "}
                        <Link
                            className={cls.privacyLink}
                            to='/privacy'>
                            <span
                                className={cls.privacyLink}>
                                {" "}
                                Privacy Policy
                            </span>
                        </Link>
                    </p>
                </div>
                <div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    style={{ marginTop: "80px" }}>
                    <Button
                        disabled={
                            !Boolean(
                                name &&
                                    email &&
                                    phone &&
                                    message &&
                                    checked
                            )
                        }
                        className={cls.formButton}
                        onClick={() => onSubmit()}
                        size='large'
                        variant='primary'>
                        Contact with us
                        <div
                            className={classNames(
                                cls.arrow,
                                [],
                                {
                                    [cls.hover]: isHover,
                                }
                            )}>
                            <Icon type='arrow-up-right' />
                        </div>
                    </Button>
                </div>
                {isSent && (
                    <div className={cls.successMessage}>
                        Your message has been sent!
                    </div>
                )}
                <div className='app-orbit-container contact-block-orbit'>
                    <div className='app-orbit contact-block-orbit' />
                    <div className='app-orbit second-orbit contact-block-orbit' />

                    <div className='app-anim-circle contact-block-orbit'>
                        <div className='app-anim-dot contact-block-orbit' />
                        <div className='app-anim-dot second-dot contact-block-orbit' />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}
